module.exports = __webpack_public_path__ + "static/img/GD.38cd5b8c.svg";